import { Modal } from '../../UI/components/Modal';
import { useSideOverContext } from '../../UI/components/SideOver';
import { openNotification, Person, useDeletePerson } from '../../../src/';
import { useTranslation } from 'react-i18next';

type PersonDeleteModalProps = {
  isModalOpen: boolean;
  setIsModalOpen: (value: boolean) => void;
  person: Person;
};

export function PersonDeleteModal({ isModalOpen, setIsModalOpen, person }: PersonDeleteModalProps) {
  const { closeSideOver } = useSideOverContext();
  const { t: tPerson } = useTranslation('person');
  const { deletePerson } = useDeletePerson();

  return (
    <Modal
      isOpen={isModalOpen}
      okThemeType="danger"
      onExitComplete={(source) => {
        if (source === 'ok') closeSideOver();
      }}
      cancel={() => setIsModalOpen(false)}
      okLoading={deletePerson.isLoading}
      onOk={() =>
        deletePerson.mutate(
          { id: person.id, householdID: person.householdID },
          {
            onSuccess: () => {
              setIsModalOpen(false);
              closeSideOver();
              openNotification({
                description: tPerson('remove-person-success'),
              });
            },
          }
        )
      }
      okText={tPerson('remove-individual-modal-ok')}
      cancelDisabled={deletePerson.isLoading}
      title={tPerson('remove-individual-modal-title')}
      bodyText={tPerson('remove-individual-modal-body')}
      className="fixed inset-x-0 md:inset-x-auto bottom-4 sm:bottom-16 m-auto md:right-16 z-50 w-[calc(100vw_-_32px)] sm:!w-[542px]"
    />
  );
}
